import React from "react";
import { Link } from "react-router-dom";
import { Anchor } from "@ebscois/react-component-library";
import { StyledCmeButton } from "./_.styled";

const CmeButton = ({
  buttonSize,
  buttonUrl,
  buttonLabel,
  counterValue,
  isExternalNavigation,
}) => {
  const buttonText = (
    <>
      {buttonLabel}{" "}
      {!!counterValue && (
        <span data-testid="ce-cme-button-counter">&nbsp;{counterValue}</span>
      )}
    </>
  );

  return (
    <Anchor
      data-testid="ce-cme-button"
      href={buttonUrl}
      linkComponent={isExternalNavigation ? "a" : Link}
    >
      <StyledCmeButton size={buttonSize}>{buttonText}</StyledCmeButton>
    </Anchor>
  );
};

export default CmeButton;
